import * as zod from "zod";

const urlField = (msg?: string) =>
  zod.string().url(msg ?? "正しいURLを入力してください");

export const optionalUrlField = (msg?: string) =>
  urlField(msg).optional().or(zod.literal("")).nullable();
